module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bb0iH"))).then(() => parcelRequire('f4eak'));